export const checkRules = password => {
  const rules = {
    length: false,
    upper: false,
    lower: false,
    symbol: false
  };

  // Make sure it's at least 8 characters long (spaces not included)
  if (password.replace(/ /g, '').length >= 8) {
    rules.length = true;
  }

  // Make sure there's at least 1 uppercase character
  if (password.replace(/[^A-Z]/g, '').length > 0) {
    rules.upper = true;
  }

  // Make sure there's at least 1 lowercase character
  if (password.replace(/[^a-z]/g, '').length > 0) {
    rules.lower = true;
  }

  // Make sure there's at least 1 number or symbol
  if (password.replace(/ /g, '').replace(/[^\W\d]/g, '').length > 0) {
    rules.symbol = true;
  }
  return rules;
};
export const getRuleStyle = pass => {
  const returnValue = pass ? {
    color: 'black'
  } : {
    color: 'red'
  };
  return returnValue;
};
export const isValid = password => {
  const rules = checkRules(password);
  return rules.length && rules.upper && rules.lower && rules.symbol;
};